/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

import alertsService from '@/services/toolbox/alerts-service';
import { ERROR_DETAILS } from '../../constants/error-details';

const state = {};

const mutations = {
	SET_USER_ALERTS(state, alertsPayload) {
		Object.assign(state, alertsPayload);
	},

	SET_ALL_ALERT_PREFERENCES(state, preferences) {
		state.preferences = preferences;
	},

	GET_ALL_PREFERENCES(state, getAllPreferencesPayload) {
		if (getAllPreferencesPayload.length >= 1) {
			const pref = {
				preferences: [
					...getAllPreferencesPayload[0].userPreferences[0].preferences,
				],
				watchResponses: [...getAllPreferencesPayload[0].watchResponses],
				count: getAllPreferencesPayload[0].count,
				isEdited: false,
			};
			Object.assign(state, pref);
		} else {
			const pref = {
				preferences: [],
				watchResponses: [],
				count: null,
				isEdited: false,
			};
			Object.assign(state, pref);
		}
	},

	UPDATE_ALERT_VALUE(state, data) {
		const parts = data.key.toString().split('.');
		const lastKey = parts.pop();
		const lastObj = parts.reduce(
			(currentObject, key) => (currentObject[key] = currentObject[key] || {}),
			state.preferences[data.preferenceIndex],
		);
		lastObj[lastKey] = data.value;
	},
	UPDATE_BORROWER_EMAIL_NOTIFICATION(state, data) {
		state.preferences[data.preferenceIndex].recipientNotifications[
			data.borrowerIndex
		].notifications[0].activeInd = data.value;
	},
	UPDATE_BROKER_NOTIFICATION(state, data) {
		const brokerNotificationIndex = state.preferences[
			data.preferenceIndex
		].recipientNotifications.findIndex((x) => x.recipientType === 'Broker');

		state.preferences[data.preferenceIndex].recipientNotifications[
			brokerNotificationIndex
		].notifications[data.index].activeInd = data.value;
	},

	ALERTS_ISEDITED(state, value = false) {
		state.isEdited = value;
	},
};

const actions = {
	async setUserAlerts({ commit }, userId) {
		const data = await alertsService.getAlerts(userId);
		commit('SET_USER_ALERTS', data);
	},

	async getAllPreferences({ commit, dispatch }, userIds) {
		try {
			const data = await alertsService.getAllPreferences(userIds);
			commit('GET_ALL_PREFERENCES', data);
		} catch (error) {
			dispatch('showErrorModal', {
				error,
				errorDetails: ERROR_DETAILS.GET_ALL_PREFERENCES,
			});
			return Promise.reject(error);
		}
	},
	setAllAlertPreferences({ commit }, preferences) {
		commit('SET_ALL_ALERT_PREFERENCES', preferences);
	},
	updateAlertValue({ commit }, data) {
		commit('UPDATE_ALERT_VALUE', data);
		commit('ALERTS_ISEDITED', true);
	},
	updateEmailTextValues({ commit }, data) {
		commit('UPDATE_BROKER_NOTIFICATION', data);
		commit('ALERTS_ISEDITED', true);
	},
	updateBorrowerEmailNotification({ commit }, data) {
		commit('UPDATE_BORROWER_EMAIL_NOTIFICATION', data);
		commit('ALERTS_ISEDITED', true);
	},
	async saveAlerts({ commit }, { contactId, preferences }) {
		try {
			const data = await alertsService.saveAlerts({
				contactId,
				preferences,
			});
			commit('ALERTS_ISEDITED');
			return Promise.resolve(data);
		} catch (error) {
			return Promise.reject(error);
		}
	},
};

const getters = {
	getPreferenceIndex: (state) => (alertName) => {
		return state.preferences.findIndex((x) => x.name === alertName);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
